export default __webpack_public_path__ + "static/media/leader_notes_detailed.cf7d5ad7.pdf";